export default __webpack_public_path__ + "static/clock-cdfa7f8bc0f7aa6cf0f039020f0f1d04.webm";